import React, { Component } from "react";
import { axiosPost } from "../../utils/AxiosApi";
import { profilePeopleId, URL } from "../../utils/Constants";
import { displayErrorAlert } from "../../utils/Utils";
import DialogBoxTemplate from "./DialogBoxTemplate";
import GameBody from "./GameBody";
import GameHeader from "./GameHeader";
import swal from "sweetalert";

class MemoryGame extends Component {
  state = {
    name: "",
    totalCards: "",
    totalPairCards: 0,
    availableColors: [
      "#000b3d",
      "#6b1fad",
      "#05e0e9",
      "#849bff",
      "#7a4900",
      "#c1ff72",
      "#ff751f",
      "#00bf63",
      "#ff3131",
      "#ff66c4",
      "#ffde59",
      "#1f48ff",
      "#0097b2",
    ],
    selectedColors: [],
    renderCards: [],
    tempCard: "",
    moves: 0,
    count: 0,
    totalMatchedPairs: 0,
    min: 3,
    sec: 0,
    showDialog: false,
    failed: false,
    isChecking: false,
  };

  componentDidMount() {
    this.getUserInfo();
  }

  componentWillUnmount() {
    clearInterval(this.startInterval);
  }

  getUserInfo = () => {
    let data = {
      peopleId: profilePeopleId,
    };
    axiosPost(
      URL.userProfileInfo,
      data,
      (response) => {
        if (response.status === 200) {
          this.setState({
            name: response.data.data.fullName,
          });
        }
      },
      (err) => {
        displayErrorAlert(err);
      },
    );
  };

  startTimer = () => {
    this.setState({ sec: this.state.sec - 1 }, function () {
      if (this.state.sec === -1) {
        this.setState({ min: this.state.min - 1 });
        this.setState({ sec: 59 });
      }
      if (this.state.min <= 0 && this.state.sec <= 0) {
        clearInterval(this.startInterval);
        this.setState({ showDialog: true, failed: true });
      }
    });
  };

  handleChange = (e) => {
    let name = e.target.name,
      value = e.target.value;
    this.setState({ [name]: value });
  };

  handleStart = () => {
    clearInterval(this.startInterval);
    this.setState({
      totalPairCards: 0,
      selectedColors: [],
      renderCards: [],
      tempCard: "",
      moves: 0,
      count: 0,
      totalMatchedPairs: 0,
      min: 3,
      sec: 0,
      failed: false,
      showDialog: false,
    });

    let totalCards = this.state.totalCards,
      name = this.state.name;
    if (totalCards === "" || name === "") {
      swal("Oops", "Enter your name and total Cards first");
    } else {
      let totalFlipCards = totalCards * totalCards,
        totalPairCards = 0;
      if (totalCards % 2 === 0) {
        totalPairCards = totalFlipCards / 2;
      } else {
        totalPairCards = (totalFlipCards - 1) / 2;
      }
      this.setState({ totalPairCards }, function () {
        this.addUniqueIdentityToCards();
      });
    }
  };

  addUniqueIdentityToCards = () => {
    let availableColors = this.state.availableColors,
      selectedColors = [];
    for (let i = 0; i < this.state.totalPairCards; i++) {
      selectedColors.push({
        hexCode: availableColors[i],
        selected: false,
        matched: false,
      });
    }
    selectedColors = selectedColors.concat(
      JSON.parse(JSON.stringify(selectedColors)),
    );
    if (this.state.totalCards % 2 !== 0) {
      selectedColors.push({
        hexCode: "extraCard",
        selected: false,
        matched: false,
      });
    }
    this.shuffleCards(selectedColors);
  };

  shuffleCards = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    this.setState({ selectedColors: array }, function () {
      this.manageRenderingCards();
    });
  };

  manageRenderingCards = () => {
    let allCards = this.state.selectedColors,
      totalCards = parseInt(this.state.totalCards),
      renderCards = [];
    if (allCards.length > 0) {
      let count = 0;
      for (let j = 0; j < totalCards; j++) {
        let tempCards = [];
        for (let i = 0; i < totalCards; i++) {
          tempCards.push(allCards[count]);
          count++;
        }
        renderCards.push(tempCards);
      }
    }
    this.setState({ renderCards }, function () {
      this.startInterval = setInterval(this.startTimer, 1000);
    });
  };

  handleFlip = (index, idx) => {
    if (this.state.isChecking) return;
    let renderCards = [...this.state.renderCards],
      moves = this.state.moves,
      count = this.state.count,
      totalMatchedPairs = this.state.totalMatchedPairs;
    count++;
    renderCards[index][idx].selected = true;
    if (count === 1) {
      this.setState({ tempCard: renderCards[index][idx] });
    }
    if (count >= 2) {
      this.setState({
        isChecking: true,
      });
      if (renderCards[index][idx].hexCode === this.state.tempCard.hexCode) {
        setTimeout(() => {
          renderCards.forEach((el) => {
            el.forEach((card) => {
              if (card.hexCode === renderCards[index][idx].hexCode) {
                card.matched = true;
              }
            });
          });
        }, 300);
        totalMatchedPairs = totalMatchedPairs + 1;
      }
      this.setState(
        { renderCards, moves: moves + 1, count: 0, tempCard: "" },
        function () {
          setTimeout(() => {
            this.closeAllCards();
            this.setState(
              { totalMatchedPairs, isChecking: false },
              function () {
                if (totalMatchedPairs === parseInt(this.state.totalPairCards)) {
                  this.setState({ showDialog: true });
                  clearInterval(this.startInterval);
                }
              },
            );
          }, 500);
        },
      );
    } else {
      this.setState({ renderCards, count });
    }
  };

  closeAllCards = () => {
    let renderCards = [...this.state.renderCards];
    renderCards.forEach((el) => {
      el.forEach((card) => {
        card.selected = false;
      });
    });
    this.setState({ renderCards });
  };

  resetGame = () => {
    clearInterval(this.startInterval);

    this.setState({
      totalCards: "",
      totalPairCards: 0,
      selectedColors: [],
      renderCards: [],
      tempCard: "",
      moves: 0,
      count: 0,
      totalMatchedPairs: 0,
      min: 3,
      sec: 0,
      failed: false,
    });
  };

  closeDialog = () => {
    this.resetGame();
    this.setState({ showDialog: false, failed: false });
  };

  render() {
    return (
      <div className="tt-widgetContent-tab-holder" style={{ height: "79.5vh" }}>
        <div className="tt-group-header">Flash Memory Game</div>
        {/* {this.state.showDialog ? (
          <DialogBoxTemplate
            min={this.state.min}
            sec={this.state.sec}
            name={this.state.name}
            moves={this.state.moves}
            closeDialog={this.closeDialog}
          ></DialogBoxTemplate>
        ) : null} */}
        <div
          className={this.state.renderCards.length > 0 ? "minimize" : "expand"}
        >
          <GameHeader
            name={this.state.name}
            totalCards={this.state.totalCards}
            handleChange={this.handleChange}
            handleStart={this.handleStart}
          ></GameHeader>
          <hr></hr>
        </div>
        <GameBody
          totalCards={this.state.totalCards}
          renderCards={this.state.renderCards}
          handleFlip={this.handleFlip}
          moves={this.state.moves}
          count={this.state.count}
          name={this.state.name}
          min={this.state.min}
          sec={this.state.sec}
          showDialog={this.state.showDialog}
          closeDialog={this.closeDialog}
          failed={this.state.failed}
        ></GameBody>
      </div>
    );
  }
}

export default MemoryGame;
